<template>

<div class="page">

    <div class="header">

        <div class="title">
            报表转换中心
        </div>

        <div class="desc">
            企业数据智能转换与分析平台
        </div>

    </div>

    <div
        class="report-card"
        @click="openPerformance"
    >

        <div class="left">

            <div class="icon">
                📊
            </div>

            <div>

                <div class="card-title">
                    店面业绩区间表
                </div>

                <div class="card-desc">
                    根据门店业绩自动生成区间统计分析报表
                </div>

            </div>

        </div>

        <div class="right">
            进入 →
        </div>

    </div>

    <div
        class="report-card second-card"
        @click="openCustomerPerformance"
    >

        <div class="left">

            <div class="icon">
                👥
            </div>

            <div>

                <div class="card-title">
                    顾客业绩区间表
                </div>

                <div class="card-desc">
                    根据顾客业绩自动生成区间统计分析报表
                </div>

            </div>

        </div>

        <div class="right">
            进入 →
        </div>

    </div>

</div>

</template>

<script>

export default {

    methods:{

        openPerformance(){

            this.$router.push(
                '/report/performance'
            )

        },

        openCustomerPerformance(){

            this.$router.push(
                '/report/customer-performance'
            )

        }

    }

}

</script>

<style scoped>

.page{

    min-height:100vh;

    padding:30px;

    background:#f5f6f8;

}

.header{

    background:#fff;

    border-radius:12px;

    padding:24px;

    margin-bottom:24px;

    box-shadow:
      0 2px 8px rgba(0,0,0,.05);

}

.title{

    font-size:28px;

    font-weight:600;

}

.desc{

    margin-top:10px;

    color:#666;

}

.report-card{

    background:#fff;

    border-radius:12px;

    padding:24px;

    display:flex;

    justify-content:space-between;

    align-items:center;

    cursor:pointer;

    box-shadow:
      0 2px 8px rgba(0,0,0,.05);

}

.second-card{

    margin-top:20px;

}

.report-card:hover{

    transform:translateY(-2px);

    transition:.2s;

}

.left{

    display:flex;

    align-items:center;

}

.icon{

    font-size:42px;

    margin-right:20px;

}

.card-title{

    font-size:20px;

    font-weight:600;

}

.card-desc{

    margin-top:8px;

    color:#666;

}

.right{

    color:#c00000;

    font-weight:600;

    font-size:16px;

}

</style>